export default {
  companyRoadmapsMetadata: {
    titles: {
      list: 'Register of development plans',
      tasksStat: 'Plan task statistics',
    },
    stat: {
      total: 'Total plans',
      overdue_total: 'With overdue tasks',
      avg_progress: 'Average progress',
      draft_total: 'Draft',
      on_approval_total: 'Pending approval',
      revision_total: 'Revision',
      in_progress_total: 'In progress',
      on_acceptance_total: 'Pending',
      done_total: 'Completed',
      canceled_total: 'Canceled',
    },
    filters: {
      teamGroup: 'Department',
      goalType: 'Development goal type',
      reason: 'Creation reason',
      source: 'Development plan source',
      skillType: 'Skill type',
      status: 'Development plan status',
      deadline: 'Period / Deadline',
      hasOverdue: 'Has overdue tasks',
    },
    tableHeaders: {
      employee: 'Employee',
      reason: 'Creation reason',
      goalType: 'Development goal type',
      deadline: 'Deadline',
      status: 'Development plan status',
      mentor: 'Mentor',
      progress: 'Progress',
      source: 'Development plan source',
      actions: 'Actions',
    },
    taskStatItems: {
      total: 'Total',
      newCount: 'New',
      inProgressCount: 'In progress',
      doneCount: 'Completed',
      overdueCount: 'Overdue',
    },
    stubs: {
      noPlans:
        'There are no development plans yet<br/>Create the first development plan — for one employee or for a group',
    },
    // messages
    successMessages: {
      cancel: 'The development plan was canceled',
      delete: 'The draft development plan was deleted',
    },
    errorMessages: {
      load: 'Failed to load development plans',
      tasksStat: 'Failed to load task statistics',
      cancel: 'Failed to cancel the development plan',
      delete: 'Failed to delete the draft development plan',
    },
    // confirm dialogs
    confirmCancelRoadmap: {
      title: 'Cancel the development plan?',
      text: 'The plan will be moved to the «Cancelled» status. There is no way to revert from the «Cancelled» status — you cannot resume the plan; you need to create a new plan.',
      button: 'Yes, cancel',
      buttonCancel: "Don't cancel",
    },
    confirmDeleteRoadmap: {
      title: 'Delete the draft development plan?',
      text: 'The draft will be deleted without the possibility of recovery.',
    },
  },
};
